import moment from 'moment';
import { useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { useSelector } from 'react-redux';
import {
  Box,
  Card,
  CardHeader,
  Chip,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  Tooltip,
  IconButton,
  TableContainer,
  LinearProgress,
  Typography,
} from '@mui/material';
import {
  RemoveRedEyeRounded, ArrowRight,
} from '@mui/icons-material';
import { currencyFormatter } from '../../utils';
import EmptyComponent from '../EmptyComponent';
// import { updateLoan } from '../../store/orders/orders.action';

export default function LoanList({ loading, loans }) {
  const headers = [
    { label: 'Loan Number', key: 'loanNumber', width: '20%' },
    { label: 'Amount', key: 'amount', width: '15%' },
    { label: 'Date', key: 'createdAt', width: '15%' },
    { label: 'Type', key: 'loanType', width: '15%' },
    { label: 'Status', key: 'status', width: '10%' },
    { label: 'Payment', key: 'paymentStatus', width: '10%' },
    {
      label: 'Action', key: 'action', width: '10%',
    },
  ];

  const navigate = useNavigate();
  // const dispatch = useDispatch();

  // const { loanTypes } = useSelector((state) => state.app);

  const getLabelColor = (status) => {
    let color;
    if (status === 'approved') {
      color = 'success';
    } else if (status === 'rejected') {
      color = 'error';
    } else {
      color = 'warning';
    }
    return color;
  };

  const paymentColor = (status) => {
    let color;
    if (status === 'paid') {
      // color = colors.green[300];
      color = 'success';
    } else if (status === 'partially_paid') {
      // color = colors.blue[600];
      color = 'success';
    } else {
      // color = colors.amber[500];
      color = 'warning';
    }
    return color;
  };

  return (
    <PerfectScrollbar>
      <Box sx={{ minWidth: 800 }}>

        {loading && (
        <Box sx={{ width: '100%' }}>
          <LinearProgress />
        </Box>
        )}

        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                {headers.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    width={column.width}
                  >
                    <Typography sx={{ fontWeight: 'bold' }}>{column.label}</Typography>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            {!loading && loans.length === 0 && (
            <TableBody>
              <TableRow style={{ height: 300 }}>
                <TableCell colSpan={12}>
                  <EmptyComponent />
                </TableCell>
              </TableRow>
            </TableBody>
            )}

            {loans && loans.length > 0 && (
              <TableBody>
                {loans.map((loan) => (
                  <TableRow
                    hover
                    key={loan.loanNumber}
                  >
                    <TableCell>
                      {loan.loanNumber}
                    </TableCell>
                    <TableCell>
                      {currencyFormatter(loan.amount)}
                    </TableCell>
                    <TableCell>
                      {moment(loan.createdAt).format('DD MMM, YYYY')}
                    </TableCell>
                    <TableCell>
                      {loan.loanType.name}
                    </TableCell>
                    <TableCell>
                      <Chip
                        color={getLabelColor(loan.credit.creditStatus)}
                        label={loan.credit.creditStatus.toUpperCase()}
                        size="medium"
                      />
                    </TableCell>
                    <TableCell>
                      <Chip
                        color={paymentColor(loan.paymentStatus)}
                        label={loan.paymentStatus.toUpperCase()}
                        variant="outlined"
                      />
                    </TableCell>
                    <TableCell>
                      <IconButton><RemoveRedEyeRounded sx={{ height: 30, width: 30 }} /></IconButton>

                      {/* <IconButton onClick={() => goToDetails(order)}><CloudDownload /></IconButton> */}
                    </TableCell>
                  </TableRow>
                ))}

              </TableBody>
            )}
          </Table>
        </TableContainer>

      </Box>
    </PerfectScrollbar>
  );
}

LoanList.propTypes = {
  loans: PropTypes.array,
  loading: PropTypes.bool,
};
